module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAABYlAAAWJQFJUiTwAAABJ0lEQVR4nO3Z0Y2DMBCE4VUqSkmUkg4owSWmhOSFkSzWGANGxp75JKTTJrq7+ZW3mIiIiLTyWR5av+Vp5sX+2VcAdyGjAO5CRgHchYwCuAsZBXAXMgrgLmQUwF3IKIC7kFEAdyGjAO5CRgHchYwCuAsZBXAXMgrgLnlvM/ua2ZR9VxvT8r+97/zrc/SNbo0Itb4dnqLfNbtXKwsVI9QIEI8P7tWb1IpwNUCT8VAjwpUATcfD1QhnAzxiPFyJcCbAo8bD2QhHAzxyPJyJcCTAo8fD0QilAboYD0cilAToajyURtgL0OV4KImQC9D1eNiLsBVgiPGQi5AKMNR42IqwDjDkeEhFiAMMPR7WEVI/Dzse4gjrZ/jxkIpAMx4C83gIzONFRNoysz9ISp57FyNKGwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@2x/ic_arrow_bk_1@2x.png
// module id = 1087
// module chunks = 0